import React, { useState } from 'react';
import { Dialog, DialogTrigger, DialogContent, DialogClose } from '@/components/atoms/Dialog';
import { Button } from '@/components/atoms/PcButton';
import KaKaoIcon from '@/assets/icons/More/payment_icon_yellow_large 1.svg?react';
import ChangeBillCard from './ChangeBillCard';
import ChangeBillKakao from './ChangeBillKakao';
import { useAppSelector } from '@/redux/store';

const ChangeBill = () => {
  const [changeBillOptions, setChangeBillOptions] = useState<'KAKAO_PAY' | 'CARD'>('KAKAO_PAY');
  const ServiceInfo = useAppSelector((state: any) => state.user.ServiceInfo);
  const [billDialogOpen, setBillDialogOpen] = useState(false);
  // 무료 체험 여부를 확인하기 위한상태
  const isAnySubscribed = ServiceInfo.AppSellerInfo.IsAnySubscribed;
  const subscriptionNo = isAnySubscribed ? 23 : 22; // 무료 체험 대상 즉 isAnySubscribed가 false인지 확인 22, 아니면 23
  const isPrePayment = true;
  const paymentAmount = 15000;

  const billProps = {
    isPrePayment,
    subscriptionNo,
    paymentAmount,
    setBillDialogOpen,
  };

  const renderChangeBillForm = () => {
    switch (changeBillOptions) {
      case 'KAKAO_PAY':
        return <ChangeBillKakao {...billProps} />;
      case 'CARD':
        return <ChangeBillCard {...billProps} />;
      default:
        return <ChangeBillKakao {...billProps} />;
    }
  };
  return (
    <Dialog open={billDialogOpen} onOpenChange={setBillDialogOpen}>
      <DialogTrigger asChild>
        <Button
          variant="outline"
          className="h-[34px] rounded-sm border-gr-200 px-2.5 py-1.5 text-gr-700 shadow-none Body5M14"
        >
          결제수단 변경
        </Button>
      </DialogTrigger>
      <DialogContent noCloseBtn className="w-full max-w-[580px]">
        <div className="flex flex-col items-start gap-8">
          <div className="flex w-full flex-col gap-3">
            <h1 className="text-gr-900 Body1S16">결제 수단 변경</h1>
            <div className="flex w-full items-start justify-between">
              <div className="pt-[11px] text-gr-800 Body2M16">변경할 결제 수단</div>
              <div className="flex h-[46px] rounded-[12px] bg-gr-100 p-[6px]">
                {/* 카카오페이 */}
                <div
                  className={`flex w-[140px] cursor-pointer items-center justify-center gap-[6px] rounded-[8px] transition
                  ${changeBillOptions === 'KAKAO_PAY' ? 'bg-white shadow' : 'bg-gr-100'}
                `}
                  onClick={() => setChangeBillOptions('KAKAO_PAY')}
                >
                  <KaKaoIcon />
                  <span className="text-gr-700 Body5M14">카카오페이</span>
                </div>
                {/* 카드결제 */}
                <div
                  className={`flex w-[140px] cursor-pointer items-center justify-center gap-[6px] rounded-[8px] transition
                  ${changeBillOptions === 'CARD' ? 'bg-white shadow' : 'bg-gr-100'}
                `}
                  onClick={() => setChangeBillOptions('CARD')}
                >
                  <span className="text-gr-700 Body5M14">일반 카드</span>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full transition-all">{renderChangeBillForm()}</div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ChangeBill;
